import { CSSProperties } from 'react';

import { nameAgeStyle } from '@/components/Discovery/Card/Components/Bio.tsx';
import UIConfig from '@/UIConfig.ts';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';
import { LocationSubtitle } from '@/components/Discovery/Card/Components/Content.tsx';

type NameAgeBlockProps = {
  name?: string;
  age?: number;
  distance: number;
};

export const NameAgeBlock = ({ name, age, distance }: NameAgeBlockProps) => {
  return (
    <div style={containerStyle}>
      <div className="cardHeaderName" style={nameAgeStyle}>
        {name}
        {age !== 0 && <span>,&nbsp;{age}</span>}
        &nbsp;
        <VerifiedBadgeShape
          width={24}
          height={24}
          style={{ marginBottom: 2 }}
        />
      </div>
      <LocationSubtitle geoProximity={distance} />
    </div>
  );
};

const containerStyle: CSSProperties = {
  padding: '5px 15px',
  backgroundColor: UIConfig.Colors.BackgroundDark,
  borderRadius: '0 0 15px 15px'
};
